import {gsap, Linear} from "gsap";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
export class BruteForceHelper{
    public static resetSpineItem(item: PIXI.spine.Spine): void {
        item.state.clearTracks();
        item.skeleton.setToSetupPose();
        item.skeleton.setSlotsToSetupPose();
       // item.updateTransform();
        item.state.setEmptyAnimation(0, 0);
    }

    public static playSpineWithTimeline(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): gsap.core.Timeline {
        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            throw new Error(`No animation named ${animationName}`);
        }

        spine.autoUpdate = false;

        const setAnimation = () => {
            const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
            trackEntry.alpha = animationAlpha;
            trackEntry.mixDuration = mixDuration;
        }

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        }

        const updateFunc = () => {
            const now = target.playHead;
            spine.update(now - target.prevTime);
            target.prevTime = now;
        }

        const tl = gsap.timeline();
        tl.add(() => {
            target.prevTime = 0;
            setAnimation()
        });
        tl.add(gsap.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        }))
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.add(gsap.to(target, {duration: 0.0001})); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc()
        })

        return tl;
    }

    public static spineAnimDuration(spine: PIXI.spine.Spine, animName: string): number {
        return spine.spineData.findAnimation(animName).duration;
    }

    public static symShakeWiggle1 = CustomWiggle.create("symShakeWiggle1", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
}